<template>
    <div ref="BigMain" @scroll="scrollEvent">
        <navigation-bar Bell/>
        <div class="main" @scroll="scrollEvent" ref="main" :class="{ openBox: isActive }">

            <!--下拉重刷插槽-->
            <Refresh :scrollTops="scrollTop" @result="setupData">

            <div class="logo"><Logo/></div>

            <!--骨架屏-->
            <el-skeleton :loading="loadingBanner" animated class="home-banner">
                <template slot="template">
                    <el-skeleton-item variant="image" class="skeleton-top-banner"/>
                </template>
                <!--TODO:廣告輪播-->
                <template>
                    <banner id="top-banner" class="mb-2" :list="bannerList" @onClickEvent="onBannerClickEvent"/>
                </template>
            </el-skeleton>

            <!--todo 搜尋-->
            <div class="search-block">
                <div @click="$router.push({name: 'Search'})" class="search-box">
                    今天想找什麼呢？
                </div>
            </div>

            <!--todo 第一層分類icon-->
            <quick-menu class="mb-2"/>

            <div v-if="questList.length > 0" class="mt-4">
                <!--TODO:問卷輪播-->
                <quest :list="questList"/>
                <el-divider class="mb-0"/>
            </div>

            <div class="shadow-line m-0"/>

            <!--骨架屏-->
            <el-skeleton :loading="loadingCoupon" animated :count="2">
                <template slot="template">
                    <div class="skeleton-coupon">
                        <div class="max-w-150 mr-3">
                            <el-skeleton-item variant="h3"/>
                            <el-skeleton-item variant="image"/>
                            <el-skeleton-item variant="text"/>
                        </div>
                    </div>
                </template>
                <template>
                    <category-content>
                        <category-header :to="{ name: 'Complex', query:{showType: searchTypeQuery[0]}}" title="搶券熱區" v-if="ticketList.length > 0"/>
                        <item-grid>
                            <ticket-item :list="ticketList" :PreviewNum="9"/>
                        </item-grid>
                    </category-content>
                </template>
            </el-skeleton>

            <category-content v-if="newStoreList.length > 0">
                <category-header :to="{ name: 'Store', query:{defaultTab: 'third'}}" title="新店報報"/>
                <item-grid>
                    <article-cover :list="newStoreList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar :PreviewNum="9"/>
                </item-grid>
            </category-content>

            <!--<category-content v-if="takeoutStoreList.length > 0">
                <category-header title="外帶外送" :to="{ name: 'Complex', query:{showType: searchTypeQuery[1]}}"/>
                <item-grid>
                    <article-cover :list="takeoutStoreList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar :PreviewNum="9"/>
                </item-grid>
            </category-content>

            <category-content v-if="bookingStoreList.length > 0">
                <category-header title="線上訂位" :to="{ name: 'Complex', query:{showType: searchTypeQuery[2]}}"/>
                <item-grid>
                    <article-cover :list="bookingStoreList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar :PreviewNum="9"/>
                </item-grid>
            </category-content>-->

            <category-content v-if="shoppingAreaList.length > 0">
                <category-header :to="{ name: 'Complex', query:{showType: searchTypeQuery[3]}}" title="商圈夜市"/>
                <item-grid>
                    <marketplace-item :list="shoppingAreaList" :PreviewNum="9"/>
                </item-grid>
            </category-content>

            <category-content v-if="activityList.length > 0">
                <category-header :to="{ name: 'Complex', query:{showType: searchTypeQuery[4]} }" title="主題活動"/>
                <activity-item :list="activityList" :PreviewNum="2"/>
            </category-content>

            <category-content v-if="false">
                <category-header title="兒童節特餐"/>
                <item-grid>
                    <GoodsItem v-for="s in 4" :key="s"/>
                </item-grid>
            </category-content>

            <!--TODO 單圖區塊-->
            <!--<div v-if="referenceList.id > 0"
                 class="single-pic"
                 @click="$router.push({name: 'StoreInfo', query: {id: referenceList.storeId}})">
                <img :src="referenceList.imagePath">
            </div>-->
            <div class="single-pic"
                 @click="onBannerClickEvent(1,'https://www.facebook.com/shiangjuu/')">
                <img src="../../assets/images/shiangjuu_banner.jpg">
            </div>

            <!--<category-content>
                <category-header :to="{ name: 'MyComment'}">
                    <div slot="title" class="category-header">
                        <span class="title">專屬折扣</span>
                        <img src="@/assets/images/homepage/ticket.png" alt="">
                    </div>
                </category-header>
                <item-grid height="240px">
                    &lt;!&ndash;TODO:專屬折扣清單&ndash;&gt;
                    <discount-item v-for="s in 6" :key="s">
                        <img src="@/assets/images/cut2.svg" alt="">
                    </discount-item>
                </item-grid>
            </category-content>-->

            <category-content v-if="featuredArticleList.length > 0">
                <category-header :to="{ name: 'ArticleList', query:{id:0, typeId:64, isFromHomePage:true}}" title="精選特輯"/>
                <item-grid>
                    <article-card :list="featuredArticleList" :PreviewNum="9"/>
                </item-grid>
            </category-content>

            <category-content v-if="hotArticleList.length > 0">
                <category-header :to="{ name: 'ArticleList', query:{id:0, oinArticleTypeId:0, isFromHomePage:true}}" title="熱門貼文"/>
                <item-grid>
                    <article-card :list="hotArticleList" :PreviewNum="9"/>
                </item-grid>
            </category-content>

            <category-content v-if="foodArticleList.length > 0">
                <category-header title="美食特派員"/>
                <item-grid>
                    <article-card :list="foodArticleList"/>
                </item-grid>
            </category-content>
            </Refresh>
        </div>

        <comm-dialog v-bind="cDialog" class="dialog-dark" @result="onCommDialogClose"/>

        <!--todo 跳窗訊息彈窗-->
        <PopupMessage v-bind="popupDialog" class="popup-message" @result="handlePopup"
                      :is-close-on-click-modal="false" :key="currentAlertMessageIndex"/>

        <toast/>
    </div>
</template>

<script>
    import CategoryContent from '../../components/category/Content'
    import CategoryHeader from '../../components/category/Header'
    import Banner from '../../components/BannerSlider'
    import Quest from '../../components/QuestSlider'
    import QuickMenu from '../../components/QuickMenuComplex'
    import TicketItem from './components/TicketItem'
    import ItemGrid from '../../components/category/ItemGrid'
    import ArticleCard from '../../components/category/ArticleCard'
    import ActivityItem from '../activity/components/ActivityItem'
    import CommDialog from '../../components/CommDialog'
    import PopupMessage from '../../components/CommDialog'
    import MarketplaceItem from '../complex/components/MarketplaceItem'
    import GoodsItem from "../complex/components/GoodsItem";
    import ArticleCover from '@/components/article/ArticleCover'
    import * as constDefine from '@/store/constDefine'
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"
    import Refresh from "../../components/Refresh";
    import sqlite from "@/util/sqlite";
    import Logo from "@/components/Logo";
    import {SpinnerWheelType} from "@/store/constDefine"
    import shortUrl from "@/util/shortUrl";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
    export default {
        name: "Home",
        components: {
            Banner,
            Quest,
            //CustomCard,
            QuickMenu,
            CategoryContent,
            CategoryHeader,
            ItemGrid,
            TicketItem,
            //DiscountItem,
            ArticleCard,
            ActivityItem,
            CommDialog,
            PopupMessage,
            MarketplaceItem,
            GoodsItem,
            ArticleCover,
            Toast,
            Refresh,
            Logo,
        },
        data() {
            return {
                search: '',
                bannerList: [],
                questList: [],
                referenceList: [],
                couponList: [],
                ticketList: [],
                activityList: [],
                hotArticleList: [],             //熱門文章
                featuredArticleList: [],        //精選特輯
                foodArticleList: [],
                shoppingAreaList: [],           //商圈列表
                cDialog: {                    // commDialog 用
                    value: false,
                    eventType: 0,
                    outerContent: '',
                    mainContent: '',
                    isModal: false,
                    isCancel: false,
                    isShowClose: false,
                },
                openUrl: '',
                isActive: false,
                scrollTop:0,
                storeList: [1,2,3],

                takeoutStoreList: [],       //可外帶
                bookingStoreList: [],       //可訂位
                newStoreList: [],           //新店報報
                lng: 0,
                lat: 0,
                searchTypeQuery: [constDefine.TAB_ID_COUPON,
                    constDefine.TAB_ID_TAKEOUT,
                    constDefine.TAB_ID_BOOKING,
                    constDefine.TAB_ID_MARKET,
                    constDefine.TAB_ID_ACTIVITY,
                    constDefine.TAB_ID_STORE,],
                //骨架屏載入-廣告輪播
                loadingBanner: true,
                //骨架屏載入-優惠卷清單
                loadingCoupon: true,

                wheelGameLoadedAt: null,
                wheelGameTypeDefinition: SpinnerWheelType,
                //跳窗訊息
                popupDialog: {
                    value: false,
                    outerContent: '',
                    icon: '',
                    isCancel: true,
                    positiveLabel: '',
                    negativeLabel: '',
                    isCloseOnClickModal: true,
                },

                alertMessage: {
                    alertType: 0,
                    id: 0,
                    imageLink: '',
                    message: '',
                    closedAt: '',
                    questionnaireId: 0,
                    questionnaireUrl: '',
                },
                alertMessageList: [],
                currentAlertMessageIndex: 0,
                isFirstLoad: true,

            }
        },
        created() {
            this.setupData();
        },
        mounted() {

        },
        /*beforeRouteEnter(to, from, next){
            //this.$store.commit("set_scrollTop",this.scroll);
            /!*if(from.name === 'CouponList'){
                to.meta.isBack = true;
            }*!/
            next();
        },*/
        activated () {

            const fullWidth = window.innerWidth;
            if(fullWidth>=1024){
                //網頁版紀錄捲動位置
                this.$refs.BigMain.scrollTop = this.scrollTop;
            }else{
                //手機版紀錄捲動位置
                this.$refs.main.scrollTop = this.scrollTop;
            }
            this.getSeizeTicketList();
            this.getWheelGame(this.wheelGameTypeDefinition.HOMEPAGE.VALUE).then(gameSetting => {
                if (JSON.stringify(gameSetting) !== JSON.stringify({})) {
                    this.$router.replace({name: 'Turntable', params: {settingData: JSON.stringify(gameSetting),
                            type: this.wheelGameTypeDefinition.HOMEPAGE.VALUE.toString()}});
                } else {
                    if (this.isFirstLoad) {
                        this.getPopup();
                    }
                }
                this.isFirstLoad = false;
            });

            if (this.$route.params.from === "Turntable" ) {
                this.getPopup();
            }


        },
        methods: {
            scrollEvent() {

                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scrollTop = this.$refs.BigMain.scrollTop;
                }else {
                    //手機版紀錄捲動位置
                    this.scrollTop = this.$refs.main.scrollTop;
                }

                //偵測區塊捲動的高度手機版搜尋用
                let scroll = this.$refs.main.scrollTop
                //偵測banner的高度
                let HH = document.getElementById("top-banner").offsetHeight - 40
                if (scroll > HH) {
                    this.isActive = true
                }
                if (scroll <= HH) {
                    this.isActive = false
                }
            },
            setupData: function () {

                let self = this;
                //取得 GPS
                self.getGpsLocation()
                    .then( () => {
                            return self.getExtensionStoreList(constDefine.STORE_TAKEOUT);
                        }
                    )
                    .then( () => {
                            //如果函式後有括號，外面要加上空函式宣告，裡面也要有 return，才會是跟上一步驟同步的(要等上面執行完才接着執行)
                            //若是沒有 return的話會變成非同步式，它不等上個步驟執行完就會開始執行
                            return self.getExtensionStoreList(constDefine.STORE_BOOKING);
                        }
                    )
                    .then(
                        //新店報報
                        self.getNewStoreList
                    )
                    .then (
                        //如果函式後沒有括號，可以直接跟上一步驟連接成同步 (要等上面執行完才接着執行)
                        self.getShoppingAreaList
                    )
                    .catch( (error) => {
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

                //廣告輪播
                this.$http.fetch`OinAdvertisementList${{}}
                ${json => {
                    self.bannerList = json.data;
                    self.$nextTick(function () {
                        self.loadingBanner = false
                    });
                }}`;

                //首頁推薦
                this.$http.fetch`OinTopReferenceInfo${{}} ${json => {
                    self.referenceList = json.data;
                }}`;

                //問卷
                this.$http.fetch`QuestionnaireList${{}} ${json => {
                    // console.log('QuestionnaireList:' + JSON.stringify(json));
                    self.questList = json.data;
                }}`;

                //優惠卷清單
                // this.getCouponList();
                //搶券清單
                this.getSeizeTicketList();

                //主題活動列表
                this.$http.fetch`GetOinActivityList${{}}
                ${json => {
                    self.activityList = json;
                }}`;

                //熱門貼文
                this.$http.fetch`HotArticleList${{
                    typeId: -1,
                    oinArticleTypeId: -1,
                    offset: 0,
                }}
                ${json => {
                    self.hotArticleList = json.data;
                }}`;

                //精選特輯
                this.$http.fetch`HotArticleList${{
                    typeId: -1,
                    oinArticleTypeId: 64,
                    offset: 0,
                }}
                ${json => {
                    self.featuredArticleList = json.data;
                }}`;

                //美食特派員
                //暫時取消，可能跟輔英有衝突
                // this.$http.fetch`HotArticleList${{
                //     typeId: 9,
                //     offset: 0,
                // }}
                // ${json => {
                //     self.foodArticleList = json.data;
                // }}`;


            },

            /** 顯示訊息 dialog */
            showDialog: function (title, msg, cancelable = false, eventType = 0) {
                this.cDialog.value = true;
                this.cDialog.outerContent = title;
                this.cDialog.mainContent = msg;
                this.cDialog.isCancel = cancelable;
                this.cDialog.eventType = eventType;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose: function (result, eventType) {
                this.cDialog.value = false;

                if (eventType === 0) {
                    if (result) {
                        this.$router.push({name: 'Login'});
                    } else {
                        this.$router.go(-1)
                    }
                } else if (eventType === 1) {
                    //type == 1，開啓 url
                    if (result) {
                        let isCordova = !!window.cordova;
                        if (isCordova) {
                            if (this.openUrl.startsWith('https://survey.oinapp', 0) || this.openUrl.startsWith('https://survey-test.oinapp', 0)) {
                                if (this.openUrl.includes('questionnaire/')) {
                                    this.checkQuestionnaire();
                                } else if (this.openUrl.includes('form/')) {
                                    this.$public.openUrlWithCloseBtn(this.openUrl);
                                }
                            } else {
                                //開啓頁面
                                this.$public.openUrl(this.openUrl);
                            }
                        } else {
                            window.open(this.openUrl);
                        }
                    }
                }
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        // console.log(`getGpsLocation onSuccess: self.lng:${self.lng}, self.lat:${self.lat}`);
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /**
             * 取得可訂位可外帶的店家列表
             * searchExtension: 1：可訂候位, 2：可外帶外送
             * */
            getExtensionStoreList: function (extensionType) {

                let self = this;

                let searchExtension = 0;
                if (extensionType === constDefine.STORE_TAKEOUT || extensionType === constDefine.STORE_BOOKING) {
                    searchExtension = extensionType;
                }

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreExtensionList${{
                        searchType: 2,    //0：熱門店家、1：最新店家、2：離我最近、3：高度評價、4： 隨機店家
                        offset: 0,
                        lng: self.lng,
                        lat: self.lat,
                        searchExtension: searchExtension,
                        searchText: '',
                        // storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        // subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {
                        if (self.$public.notNull(json)) {
                            if (self.$public.notNull(json.data)) {
                                if (searchExtension === constDefine.STORE_TAKEOUT) {
                                    self.takeoutStoreList.tmz_load_push(...json.data);
                                } else if (searchExtension === constDefine.STORE_BOOKING) {
                                    self.bookingStoreList.tmz_load_push(...json.data);
                                }
                            }

                            //完成
                            resolve();

                        } else {

                            //失敗
                            reject('失敗');
                        }

                    }}`;
                });
            },

            /** 取得附近店家列表 */
            getNewStoreList: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreList${{
                        searchType: 1,  //0：熱門店家、1：最新店家、2：離我最近、3：高度評價、4： 隨機店家
                        offset: 0,
                        lng: self.lng,
                        lat: self.lat,
                        storeTypeId: undefined,
                        subStoreTypeId: undefined,
                    }} ${json => {
                        //imgUrl: banner圖片網址, imgLogoUrl: logo圖片網址, frontUrl: 封面
                        if (self.$public.notNull(json)) {
                            if (self.$public.notNull(json.data)) {
                                self.newStoreList.tmz_load_push(...json.data);
                            }

                            //完成
                            resolve();

                        } else {
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /** 取得商圈列表 */
            getShoppingAreaList: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    self.$http.fetch`GetShoppingAreaList${{
                        lng: self.lng,
                        lat: self.lat,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.shoppingAreaList = json.data;
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** Banner 點擊事件 */
            onBannerClickEvent: function (type, param) {
                //打開網頁
                if (param.startsWith('http://', 0) || param.startsWith('https://', 0)) {
                    this.openBannerUrl(param);
                }
            },

            /** 開啓 Banner 指定的 Url */
            openBannerUrl: async function (url) {

                //其他網頁
                if (url.startsWith('http://', 0) || url.startsWith('https://', 0)) {

                    if (url.startsWith('https://o-test.oinapp.com/') || url.startsWith('https://o.oinapp.com/')) {
                        let data = await this.getOriginalURL(url);
                        url = data.url;
                    }

                    //是否爲系統的問卷？
                    let isOpened = false;   //是否有達成開啓頁面？
                    if (url.startsWith('https://survey.oinapp', 0) || url.startsWith('https://survey-test.oinapp', 0)) {
                        const getUrlParam = urlDivideAry => {
                            let urlParam = urlDivideAry[1];
                            let paramDecode = decodeURIComponent(urlParam);
                            let paramDecrypto = this.$crypto.decryptText(paramDecode);
                            return JSON.parse(paramDecrypto);
                        }

                        if (url.includes('questionnaire/')) {
                            let urlDivideAry = url.split('questionnaire/');
                            if (urlDivideAry.length === 2) {
                                let paramData = getUrlParam(urlDivideAry);

                                // console.log('urlParam: '+ urlParam + '\n' +
                                //     'paramDecode: '+ paramDecode + '\n' +
                                //     'paramDecrypto: '+ paramDecrypto + '\n' +
                                //     'paramData: '+ paramData + '\n' );a
                                //需不需要登入？
                                if (paramData.isLogin) {
                                    let isLogin = this.$auth.isAdminLogin();
                                    if (isLogin) {
                                        // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                        const userData = getCryptoUserInfo();
                                        let name = userData.name;
                                        let tel = userData.phone;
                                        let combo = name + ';' + tel + ';APP';
                                        let crypto_ = this.$crypto.encryptText(combo);
                                        let param = encodeURIComponent(crypto_);

                                        //開啓網頁, type = 1
                                        this.openUrl = url + '/' + param;
                                        console.log('openUrl: ' + url + '/' + param);
                                        this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);

                                    } else {
                                        //沒登入的話就導到登入
                                        await this.$router.push({name: 'Login'});
                                    }

                                    isOpened = true;
                                }
                            }
                        } else if (url.includes('form/')) {
                            let urlDivideAry = url.split('form/');
                            if (urlDivideAry.length === 2) {
                                let paramData = getUrlParam(urlDivideAry);
                                paramData.params.isCordova = this.$public.isCordova();
                                let param = encodeURIComponent(this.$crypto.encryptText(JSON.stringify(paramData)));
                                url = urlDivideAry[0] + 'form/' + param;
                                let isLogin = this.$auth.isAdminLogin();
                                if (isLogin) {
                                    // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                    const userData = getCryptoUserInfo();
                                    let name = userData.name;
                                    let tel = userData.phone;
                                    let combo = name + ';' + tel + ';';
                                    combo += this.$public.isCordova() ? 'app' : 'web';
                                    let crypto_ = this.$crypto.encryptText(combo);
                                    let param = encodeURIComponent(crypto_);

                                    //開啓網頁, type = 1
                                    this.openUrl = url + '/' + param;
                                    console.log('openUrl: ' + url + '/' + param);
                                    this.showDialog('是否打開台灣享樂遊表單？', '', true, 1);
                                } else {
                                    //沒登入的話就導到登入
                                    await this.$router.push({name: 'Login'});
                                }
                                isOpened = true;
                            }
                        }

                        if (!isOpened) {
                            //開啓網頁, type = 1
                            this.openUrl = url;
                            isOpened = true;

                            // console.log('openUrl: '+ this.openUrl);
                            this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);
                        }
                    }

                    if (!isOpened) {
                        //非系統問卷
                        //開啓網頁, type = 1
                        this.openUrl = url;

                        // console.log('openUrl: '+ this.openUrl);
                        this.showDialog('是否前往外部網頁？', '', true, 1);
                    }
                }
            },

            /** 取得填過問卷的記錄 */
            callCheckQuestRecord: function (url) {
                let self = this;
                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuth`CheckCanWrite${{
                        url: url
                    }} ${json => {
                        if (json !== undefined && json.status) {
                            if (json.data !== undefined && json.data !== null) {
                                //已經填寫過問卷: false，未填寫問卷: true
                                resolve(!json.data.canWrite);
                            } else {
                                //資料是空的
                                reject('沒有查到此問卷記錄');
                            }
                        } else {
                            reject('沒有查到此問卷記錄');
                        }
                    }}`;
                });
            },

            /** 優惠卷清單*/
            getCouponList(){
                this.$http.fetch`GetCouponList${{
                    isShowHome: 1,
                    showArea: 0,
                }}
                ${json => {
                    this.couponList = json.data;
                    this.$nextTick(function () {
                        this.loadingCoupon = false
                    });
                }}`;
            },
            /** 搶券清單*/
            getSeizeTicketList(){
              this.$http.fetch`GetSeizeTicketList${{
              }}
                  ${json => {
                    if(json.status) {
                      this.ticketList = json.data;
                    }
                    this.$nextTick(function () {
                      this.loadingCoupon = false
                    });
              }}`;
            },


            /** 是否顯示備註 */
            isShowRemark() {
            },
            /** 備註 */
            getRemark() {
            },

            /** 轉盤遊戲 **/
            /***********************************************************************************************************
             * @param {number} wheelGameType select from this.wheelGameTypeDefinition (required)
             *
             * @param {number} questionnaireId (option, the default is 0)
             *
             * @param {boolean} isCheckLoadedAt (option, the default is true)
             *
             * @return {object} the returned object is like: { id: 0, limitNumber: 0, subtitle: "",title: "",
             * giftList: [ {missed: true, title: ""}, {missed: false, number: 0, subtitle: "", title: "", type: "" },… ]
             * (it might be an empty object)
             ***********************************************************************************************************/
            getWheelGame(wheelGameType, questionnaireId = 0, isCheckLoadedAt = true) {
                const isToday = (date) => {
                    if (date === undefined || date === null || date === '')
                        return false

                    const today = new Date()
                    return date.getDate() === today.getDate() &&
                        date.getMonth() === today.getMonth() &&
                        date.getFullYear() === today.getFullYear()
                }

                return new Promise((resolve, reject) => {
                    if (!this.$auth.isAdminLogin()) {
                        resolve({});
                        return;
                    }
                    if (isCheckLoadedAt){
                        if (isToday(this.wheelGameLoadedAt)){
                            resolve({});
                            return;
                        }
                    }

                    this.wheelGameLoadedAt = new Date();
                    this.$http.fetchWithAuth`GetWheelGame${{
                        "type": wheelGameType,
                        "questionnaireId": questionnaireId,
                    }}
                    ${json => {
                        if (json.status){
                            resolve(json.data);
                        } else {
                            reject('轉盤遊戲設定撈取錯誤');
                        }
                    }}`;
                })
            },

            /** 問卷檢查是否有被設定在轉盤遊戲 **/
            checkQuestionnaire() {
                let urlDivideAry = this.openUrl.split('questionnaire/');
                if (urlDivideAry.length === 2) {
                    const questionnaireId = JSON.parse(this.$crypto.decryptText(decodeURIComponent(urlDivideAry[1].split('/')[0]))).questionnaireId;
                    this.getWheelGame(this.wheelGameTypeDefinition.QUESTIONNAIRE.VALUE, questionnaireId, false).then(gameSetting => {
                        let self = this;
                        let browser = this.$public.isCordova() ? window.cordova.InAppBrowser : window;
                        let appInBrowser = browser.open(self.openUrl, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                        if (this.$public.isCordova()) {
                            if (this.$public.notNull(appInBrowser)) {
                                let loop = null;

                                appInBrowser.addEventListener('message', function(...args) {
                                    if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                        let msgObj = args[0];
                                        if (msgObj.type === 'message') {
                                            if (self.$public.notNull(msgObj.data) && self.$public.notNull(msgObj.data.message)){
                                                if (msgObj.data.message.indexOf('complete') >= 0) {
                                                    setTimeout(() => {
                                                        appInBrowser.close();

                                                        if (JSON.stringify(gameSetting) !== JSON.stringify({})) {
                                                            self.$router.replace({name: 'Turntable', params: {settingData: JSON.stringify(gameSetting),
                                                                    type: self.wheelGameTypeDefinition.QUESTIONNAIRE.VALUE.toString()}});
                                                        } else {
                                                            this.currentAlertMessageIndex++;
                                                            this.showPopup();
                                                        }
                                                    }, 1000)
                                                } else if (msgObj.data.message.indexOf('close') >= 0) {
                                                    appInBrowser.close();
                                                }
                                            }
                                        }
                                    }
                                }, false);

                                //監聽 '載入完成' 事件
                                appInBrowser.addEventListener('loadstop', function(event) {

                                    // appInBrowser.executeScript({
                                    //     code: "document.getElementById('closeBtn').addEventListener(\"click\",function(e){" +
                                    //         "const message = {message: 'close'};" +
                                    //         "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));" +
                                    //         "},false);"
                                    // });

                                    //setInterval，會一直取得網頁位址
                                    loop = setInterval(function() {

                                        appInBrowser.executeScript(
                                            {
                                                //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                                code: "location.href;"
                                            },
                                            function( values ) {
                                                // console.log(`#### executeScript url = ${JSON.stringify(values)}`);

                                                //植入另一段 javascript
                                                if (self.$public.notNull(values) && self.$public.notNull(values[0]) && values[0].indexOf('complete') >= 0) {

                                                    //停止迴圈
                                                    clearInterval( loop );

                                                    appInBrowser.executeScript({
                                                        code: "const func = function(){ const message = {message: 'complete'}; " +
                                                            "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message))}();"
                                                    });
                                                }
                                            }
                                        );
                                    }, 1000);
                                }, true);

                            }
                        }
                    });
                }
            },

            /** 取彈窗資料 **/
            getPopup() {
                if (this.$auth.isAdminLogin()) {
                    this.$http.fetchWithAuth`GetAlertDetail${{}}
                    ${json => {
                        if (json.status) {
                            this.alertMessageList = json.data;
                            if (this.alertMessageList.length !== 0) {
                                this.showPopup();
                            }
                        }
                    }}`;
                }
            },
            /** 彈窗顯示 **/
            async showPopup() {
                if (this.currentAlertMessageIndex < this.alertMessageList.length) {
                    this.alertMessage = this.alertMessageList[this.currentAlertMessageIndex];
                    let isShow = await this.handleSqliteRecord();
                    if (!isShow) {
                        this.popupDialog.value = false;
                        this.currentAlertMessageIndex++;
                        await this.showPopup();
                        return
                    }

                    this.popupDialog.value = true;
                    this.popupDialog.icon = this.alertMessage.imageLink;
                    this.popupDialog.outerContent = this.alertMessage.message.replace(/\r?\n/g, '<br />');
                    this.popupDialog.isCancel = this.alertMessage.questionnaireId !== 0;
                    this.openUrl = this.alertMessage.questionnaireUrl;
                    this.changePopupLabelDisplay();
                } else {
                    this.currentAlertMessageIndex = 0;
                    this.alertMessageList = [];
                    this.alertMessage = this.$options.data.call(this).alertMessage;
                    this.popupDialog.value = false;
                    this.openUrl = '';
                }
            },
            /** 彈窗事件處理 **/
            handlePopup(arg, eventType) {
                if (this.popupDialog.isCancel) {
                    if (!arg) {
                        this.currentAlertMessageIndex++;
                        this.showPopup();
                    } else {
                        let url = this.openUrl;
                        if (url.startsWith('https://survey.oinapp', 0) || url.startsWith('https://survey-test.oinapp', 0)) {
                            if (this.$auth.isAdminLogin()) {
                                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                const userData = getCryptoUserInfo();
                                let name = userData.name;
                                let tel = userData.phone;
                                let combo = name + ';' + tel + ';APP';
                                let crypto_ = this.$crypto.encryptText(combo);
                                let param = encodeURIComponent(crypto_);

                                //開啓網頁, type = 1
                                this.openUrl = url + '/' + param;
                            }
                            this.checkQuestionnaire();
                        } else {
                            this.$public.showNotify('問卷載入失敗', false, 1000)
                            setTimeout(() => {
                                this.currentAlertMessageIndex++;
                                this.showPopup();
                            }, 1000)
                        }
                    }
                } else {
                    this.currentAlertMessageIndex++;
                    this.showPopup();
                }
            },
            /** 彈窗文字按鈕顯示 **/
            changePopupLabelDisplay() {
                if(this.popupDialog.isCancel) {
                    this.popupDialog.positiveLabel = '填寫問卷';
                    this.popupDialog.negativeLabel = '關閉';
                } else {
                    this.popupDialog.positiveLabel = '關閉';
                }
            },
            /** 處理sqlite儲存的紀錄 **/
            handleSqliteRecord() {
                let run = () => {
                    return new Promise(resolve => {
                        sqlite.query('SELECT * FROM alert_message WHERE id = ?', [this.alertMessage.id], (resultSet) => {
                            if (resultSet.rows.length === 0) {
                                sqlite.insert('INSERT INTO alert_message (id, read_at, alert_type, closed_at) VALUES (?, ?, ?, ?)',
                                    [this.alertMessage.id, this.$public.dateFormat('yyyy-MM-dd'), this.alertMessage.alertType, this.alertMessage.closedAt], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(true);
                                })
                            } if (this.alertMessage.alertType === 1) {
                                let data = resultSet.rows.item(0);
                                if (data.alert_type === 1) {
                                    sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                    resolve(true);
                                } else {
                                    sqlite.update('UPDATE alert_message SET read_at = ?, alert_type = ?, closed_at = ? WHERE id = ?',
                                        [this.$public.dateFormat('yyyy-MM-dd'),
                                            this.alertMessage.alertType,
                                            this.alertMessage.closedAt,
                                            this.alertMessage.id], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(true);
                                    })
                                }
                            } else if (this.alertMessage.alertType === 2) {
                                let data = resultSet.rows.item(0);
                                if (new Date(data.read_at.replaceAll("-", "/")).isToday()) {
                                    sqlite.update('UPDATE alert_message SET alert_type = ?, closed_at = ? WHERE id = ?',
                                        [this.alertMessage.alertType, this.alertMessage.closedAt, this.alertMessage.id], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(false);
                                    })
                                } else {
                                    sqlite.update('UPDATE alert_message SET read_at = ?, alert_type = ?, closed_at = ? WHERE id = ?',
                                        [this.$public.dateFormat('yyyy-MM-dd'),
                                            this.alertMessage.alertType,
                                            this.alertMessage.closedAt,
                                            this.alertMessage.id], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(true);
                                    })
                                }
                            } else if (this.alertMessage.alertType === 3) {
                                let data = resultSet.rows.item(0);
                                let today = new Date();
                                today.setHours(0,0,0,0);

                                let readDate = new Date(data.read_at.replaceAll("-", "/"));
                                readDate.setHours(0,0,0,0);

                                if (Math.ceil((Math.abs(readDate.getTime() - today.getTime())) / (1000 * 60 * 60 * 24)) < 7) {
                                    sqlite.update('UPDATE alert_message SET alert_type = ?, closed_at = ? WHERE id = ?',
                                        [this.alertMessage.alertType, this.alertMessage.closedAt, this.alertMessage.id], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(false);
                                    })
                                } else {
                                    sqlite.update('UPDATE alert_message SET read_at = ?, alert_type = ?, closed_at = ? WHERE id = ?',
                                        [this.$public.dateFormat('yyyy-MM-dd'),
                                            this.alertMessage.alertType,
                                            this.alertMessage.closedAt,
                                            this.alertMessage.id], () => {
                                        sqlite.delete("DELETE FROM alert_message WHERE closed_at < DATE('now')", []);
                                        resolve(true);
                                    })
                                }
                            }
                        })
                    })
                }

                return run();
            },
            /** 取得短網址的原始網址 **/
            async getOriginalURL(url) {
                return shortUrl.getOriginalURL(url);
            },

        },
    }
</script>
<style lang="less" scoped src="../../less/home.less"/>
<style lang="less" scoped src="../../less/skeleton.less"/>
